module.exports = __webpack_public_path__ + "static/media/jenna-ivory.34ad9d17.jpg";